import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import vodAdapter from 'shared/utils/adapters/vod';

import { normalizeVideo } from 'shared/redux/helpers/normalized';


const ACTIONS = createAsyncActions('SERVER.VIDEO.UPDATE');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;

export { SUCCESS };


export default function (data) {

  data = _.mapValues(data, function (value, prop) {
    if (prop === 'cast' || prop === 'crew') {
      return _.map(value, person => _.omit(person, 'key'));
    }

    return value;
  });

  return function (dispatch) {
    dispatch(START(data, { data: normalizeVideo(data) }));

    return vodAdapter.item.update(data)
      .then(
        function (response) {
          response = {
            ...response,
            data: normalizeVideo(response.data),
          };

          dispatch(SUCCESS(data, response));
          return response;
        },

        function (error) {
          dispatch(FAIL(data, null, { analytics: { type: 'error', name: 'dashboard.video.update' } }));
          return error;
        }
      );
  };
}



// WEBPACK FOOTER //
// ./src/dashboard/redux/server/actions/video/update.js